import { useIdentity } from './IdentityProvider';

export function useSsoHint() {
  const { ssoHint } = useIdentity();
  return ssoHint;
}
